import axios from "axios";
import { LOCATIONS } from "../../types/LocationType";

const getAllLocations = (data) => ({
  type: LOCATIONS,
  payload: data,
});

export const loadAllLocations = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("location/");
      dispatch(getAllLocations(data));
    } catch (error) {
      console.log(error.message);
    }
  };
};
